<template>
  <footer class="mobile-footer-bar w-full bg-white border-t border-[#EEEEEA] px-3.5 pt-2.5 pb-3.5 flex items-center gap-2.5 shrink-0 z-20">
    <!-- Left: View Tiles / Live Price Pill (Figma 4145:48477) -->
    <button
      type="button"
      class="view-tiles-pill w-[111px] h-10 rounded-[13px] border border-[#E2E1DC] bg-white flex flex-col items-center justify-center cursor-pointer transition-transform active:scale-95 shrink-0 focus:outline-none"
      aria-label="View Tiles"
      @click="handleViewTiles"
    >
      <span class="text-[10px] font-bold text-[#9A9994] leading-[12px] uppercase tracking-wider">
        View Tiles
      </span>
      <span class="text-[15.7px] font-extrabold text-[#2B2B2E] leading-[18px]">
        {{ myTilesPrice }}
      </span>
    </button>

    <!-- Right: Add to Cart Primary Button -->
    <button
      type="button"
      class="add-to-cart-btn flex-1 h-10 rounded-[14px] bg-[#313558] text-white flex items-center justify-center font-bold text-[14.8px] leading-[18px] transition-transform active:scale-[0.98] cursor-pointer focus:outline-none shadow-sm"
      aria-label="Add to cart"
      :disabled="isAdding"
      @click="handleAddToCart"
    >
      <span v-if="isAdding">Adding...</span>
      <span v-else>Add to Cart</span>
    </button>
  </footer>
</template>

<script setup lang="ts">
import { ModalType, useModalStore } from '~/stores/modal'
import type { ShapeMetadata } from '~/types/grid.types'

const gridStore = useGridStore()
const projectStore = useProjectStore()
const modalStore = useModalStore()
const isAdding = ref(false)

const myTilesList = computed(() => gridStore.getTilesList())
const myTilesPrice = computed(() => {
  const totalPrice = myTilesList.value.reduce(
    (acc: number, tile: ShapeMetadata) => acc + (tile.price || 0) * (tile.quantity || 1),
    0
  )
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(totalPrice)
})

const handleViewTiles = () => {
  modalStore.toggleModal(ModalType.MyTiles)
}

const handleAddToCart = async () => {
  isAdding.value = true
  try {
    await projectStore.addToCart()
  } finally {
    isAdding.value = false
  }
}
</script>

<style scoped>
.mobile-footer-bar {
  padding-bottom: max(14px, env(safe-area-inset-bottom));
}

.view-tiles-pill:hover {
  background-color: #F8F8F6;
}

.add-to-cart-btn:hover {
  background-color: #262947;
}

.add-to-cart-btn:disabled {
  opacity: 0.65;
  pointer-events: none;
}
</style>
